import { useEffect, useRef } from "react";
import DivSpinner from "../../../components/divSpinner";

const LoadingSpinner = ({ loading, cardHeight, setCardHeight }) => {
    const cardRefs = useRef([]);

    // Calculate max card height
    useEffect(() => {
        if (!loading && cardRefs.current.length > 0) {
            const heights = cardRefs.current.map(ref => ref?.offsetHeight || 0);
            if (heights.length) {
                setCardHeight(Math.max(...heights));
            }
        }
    }, [loading, setCardHeight]);

    if (!loading) return null;

    return (
        <div
            style={{
                height: cardHeight ? cardHeight + 300 : 300, // Fallback if no height yet
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <DivSpinner />
        </div>
    )
};

export default LoadingSpinner;